import { cleanClass } from '@shared/utils/cleanClass.js';
import { randomId } from '@shared/utils/randomId.js';
import Link from '@/components/Link.jsx';
import IconV2 from '@/components/v2/IconV2.jsx';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2.jsx';
import { FiArrowLeft, FiChevronDown } from '@/components/react-icons/main';

const PageTitle = ({ children, className, returnLabel, returnRoute, options, subPage, floatingSelectProps = {}, right = null }) => {
  const id = randomId();

  if (returnLabel && returnRoute) {
    return (
      <div className={'comp-page-title-wrapper'}>
        <Link to={returnRoute}>
          <IconV2 icon={FiArrowLeft} title={returnLabel} size="lg" />
        </Link>
        <h2 className={cleanClass(`comp-page-title ${subPage ? 'has-subpage' : ''} ${className || ''}`.trim())}>
          {children}
          {subPage && (
            <>
              <span className={'comp-page-title-divider'}>/</span>
              <span className={'comp-page-title-subpage'}>{subPage}</span>
            </>
          )}
        </h2>
        {options && (
          <>
            <div role={'button'} className={`mc-app-select-${id}`}>
              <IconV2 icon={FiChevronDown} />
            </div>
            <FloatingSelectV2 triggers={[`.mc-app-select-${id}`]} options={options} offset={8} {...floatingSelectProps} />
          </>
        )}
        {right}
      </div>
    );
  }
  return (
    <h2 className={cleanClass(`comp-page-title ${subPage ? 'has-subpage' : ''} ${className || ''}`.trim())}>
      {children}
      {subPage && (
        <>
          <span className={'comp-page-title-divider'}>/</span>
          <span className={'comp-page-title-subpage'}>{subPage}</span>
        </>
      )}
      {right}
    </h2>
  );
};

export default PageTitle;
